if (!customElements.get('navigation-menu')) {
  customElements.define(
    'navigation-menu',
    class NavigationMenu extends HTMLElement {
      static hasWrappedContent = false;

      constructor() {
        super();
      }

      connectedCallback() {
        if (!NavigationMenu.hasWrappedContent) {
          this.wrapMainContentAndPrependNavigation();
          NavigationMenu.hasWrappedContent = true;
        }
      }

      wrapMainContentAndPrependNavigation() {
        const main = document.querySelector('main');

        if (!main) return;

        // Check if main-content-wrapper already exists
        if (main.querySelector('.main-content-wrapper')) return;

        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('main-content-wrapper');

        // Move all children from main to wrapper div
        while (main.firstChild) {
          wrapperDiv.appendChild(main.firstChild);
        }

        main.appendChild(wrapperDiv);

        // Clone this navigation menu and prepend to main
        const navigationMenu = this.cloneNode(true);
        main.prepend(navigationMenu);

        // Remove the original navigation menu node
        this.parentNode.removeChild(this);

        // Add class to main to indicate processing is complete
        main.classList.add('main-with-navigation');
        main.classList.add('page-width');

        const parent = document.body;
        const breadcrumbs = document.querySelector('.breadcrumbs');
        parent.insertBefore(breadcrumbs, document.querySelector('#MainContent'));
        breadcrumbs.style.width = '100%';
      }
    },
  );
}
